<template>
  <!-- 收藏按钮 -->
  <div class="hero-fav" :class="{ light: theme === 'light' }" @click="show = true">
    <i class="fa-solid fa-bookmark"></i>
    <span>收藏</span>
  </div>

  <!-- 收藏引导弹窗 -->
  <div v-if="show" class="fav-mask" @click.self="show = false">
    <div class="fav-box">
      <div class="fav-close" @click="show = false">
        <i class="fa-solid fa-xmark"></i>
      </div>
      <div class="fav-icon">
        <i class="fa-solid fa-bookmark"></i>
      </div>
      <h3>收藏「数聚吴川」</h3>
      <p class="fav-desc">下次打开更方便，随时查看补贴优惠</p>
      <div class="fav-steps">
        <div class="fav-step">
          <div class="fav-step-icon fav-step-icon-dots">
            <i class="fa-solid fa-ellipsis-vertical"></i>
          </div>
          <p>点击右上角 <strong>···</strong> 按钮</p>
        </div>
        <div class="fav-step-arrow">
          <i class="fa-solid fa-arrow-down"></i>
        </div>
        <div class="fav-step">
          <div class="fav-step-icon">
            <i class="fa-solid fa-bookmark"></i>
          </div>
          <p>选择 <strong>收藏</strong></p>
        </div>
      </div>
      <div class="fav-tip">
        <i class="fa-solid fa-lightbulb"></i>
        <span>收藏后可在微信「我 → 收藏」中快速找到</span>
      </div>
      <button class="fav-btn" @click="show = false">知道了</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FavGuide',
  emits: ['update:visible'],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'dark' // 'dark' = 白色文字(蓝色背景), 'light' = 深色文字(白色背景)
    }
  },
  computed: {
    show: {
      get() { return this.visible },
      set(val) { this.$emit('update:visible', val) }
    }
  }
}
</script>

<style scoped>
.hero-fav {
  display: flex;
  align-items: center;
  gap: 4px;
  background: rgba(255, 255, 255, .2);
  backdrop-filter: blur(8px);
  color: #fff;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  cursor: pointer;
  transition: background .2s;
}

.hero-fav:active {
  background: rgba(255, 255, 255, .35);
}

.hero-fav i {
  font-size: 12px;
}

.hero-fav.light {
  background: #f3f4f6;
  color: #f97316;
}

.hero-fav.light:active {
  background: #e5e7eb;
}

/* ================================================================
   弹窗
   ================================================================ */
.fav-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, .5);
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.fav-box {
  width: 100%;
  max-width: 320px;
  background: #fff;
  border-radius: 20px;
  padding: 28px 24px;
  text-align: center;
  position: relative;
  animation: favIn .3s ease;
}

@keyframes favIn {
  from { transform: scale(.9); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}

.fav-close {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.fav-close:active { background: #e5e7eb; }
.fav-close i { font-size: 12px; color: #6b7280; }

.fav-icon {
  width: 56px;
  height: 56px;
  margin: 0 auto 12px;
  background: linear-gradient(135deg, #f97316, #ea580c);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(249, 115, 22, .3);
}

.fav-icon i { font-size: 24px; color: #fff; }

.fav-box h3 {
  font-size: 18px;
  font-weight: 800;
  color: #1f2937;
  margin-bottom: 6px;
}

.fav-desc {
  font-size: 13px;
  color: #9ca3af;
  margin-bottom: 20px;
}

.fav-steps {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
}

.fav-step {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #f9fafb;
  padding: 12px 16px;
  border-radius: 12px;
  width: 100%;
}

.fav-step-icon {
  width: 36px;
  height: 36px;
  min-width: 36px;
  background: #fff;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, .08);
}

.fav-step-icon i { font-size: 16px; color: #f97316; }
.fav-step-icon-dots i { font-size: 18px; letter-spacing: 1px; }

.fav-step p {
  font-size: 13px;
  color: #4b5563;
  text-align: left;
}

.fav-step p strong { color: #f97316; }

.fav-step-arrow {
  color: #d1d5db;
  font-size: 14px;
}

.fav-tip {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background: #fff7ed;
  padding: 8px 12px;
  border-radius: 8px;
  margin-bottom: 16px;
}

.fav-tip i { color: #f97316; font-size: 14px; }
.fav-tip span { font-size: 12px; color: #9a3412; }

.fav-btn {
  width: 100%;
  padding: 12px 0;
  border: none;
  border-radius: 22px;
  background: linear-gradient(135deg, #f97316, #ea580c);
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
}

.fav-btn:active { opacity: .85; }
</style>
